import { Component, OnInit } from '@angular/core';
import { CustomDataService } from '../services/custom-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.css']
})
export class TagsComponent implements OnInit {

  Tags 
  constructor(private custome:CustomDataService , private _router:Router) {this.Tags = this.custome.tags }

  ngOnInit() {
  }

  changeURL(tag)
  {
    
    this._router.navigate(["News/Tag",tag])
  }
}
